<template>
  <div
    class="content-dx-upload-file"
  >
    <f7-block class="profile">
      <label
        for="upload"
        class="custom-file-upload"
      >
        <i class="dx-icon dx-icon-upload" /> <div id="selectFile">Selecciona</div>
      </label>
      <input
        id="upload"
        type="file"
        :accept="acceptFiles"
        @change="onFileSelected"
      >
    </f7-block>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UploadFile',
  props: {
    urlToSend: { type: String, default: 'crop/file/up' },
    acceptFiles: { type: String, default: 'image/png, image/gif, image/jpeg, application/pdf' },
  },
  data() {
    return {
      selectedFile: '',
    };
  },
  computed: {
    ...mapState('SearcherObservations', ['fileDescription']),
  },
  methods: {
    onFileSelected(event) {
      const reader = new FileReader();
      const newFile = event.target.files[0];
      document.getElementById('selectFile').innerHTML = newFile.name;
      reader.onload = (e) => {
        this.selectedFile = `${e.target.result}`;
        this.setAttachment(newFile);
      };
      reader.onerror = (error) => {
        this.$f7.dialog.alert(`${this.$t('UploadFile_error')} ${error}`);
      };
      reader.readAsDataURL(newFile);
    },
    ...mapActions('ProjectGreenHouse', ['setAttachment']),

  },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  display: none;
}
#selectFile {
  margin-left: 0.5rem;
}
.custom-file-upload {
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: #ddd;
  display: inline-block;
  padding: 12px 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
